import request from '../../utils/request';
import { Search } from '@/DTOS/KPI/Search';

const KPIService = {
    search: (search: Search) => {
        return request('/kpiRecord/search', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },

    upsert: (
        id: any,
        formData: {
            date: any;
            week: any;
        }
    ) => {
        return request('/kpiRecord/upsert', {
            method: 'POST',
            body: JSON.stringify({
                request: {
                    id: id,
                    date: formData.date,
                    week: formData.week,
                },
            }),
        });
    },

    upsertWeek: (
        formData: {
            id: string,
            week:{
            currents: {
                id: string;
                date: string;
                value: string;
                kpiDefineId: string;
                kpiDefineLabel: string;
                kpiDefineAction: string;
                kpiDefineSection: string;
                kpiDefineLabelOrder: number;
                kpiDefineIsLastDay: boolean;
            }[]
        }
        }
    ) => {
        return request('/kpiRecord/upsertWeek', {
            method: 'POST',
            body: JSON.stringify({
                request: formData
            }),
        });
    },

    printWeek: (id: string) => {
        return request(`/kpiRecord/printWeek/${id}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                'Content-Type': 'application/json',
            }
        }, true)
    },

    reportWeek: () => {
        return request('/kpiRecord/reportWeek', {
            method: 'GET',
            credentials: 'include',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                'Content-Type': 'application/json',
            }
        });
    }
};

export default KPIService;
